import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
} from "@mui/material";
import { Controller } from "react-hook-form";

const permissionsList = [
  "add",
  "view",
  "edit",
  "delete",
  "allaccess",
  "noaccess",
];

const PermissionsTable = ({
  control,
  permissionsData,
  handlePermissionChange,
}) => {
  return (
    <TableContainer>
      <Table className="role-permission-table">
        <TableHead>
          <TableRow>
            <TableCell>Category</TableCell>
            {permissionsList.map((perm) => {
              const formattedPerm = perm
                .toLowerCase()
                .replace("allaccess", "All Access")
                .replace("noaccess", "No Access");
              return (
                <TableCell key={perm} className="role-table-fonts">
                  {formattedPerm.charAt(0).toUpperCase() +
                    formattedPerm.slice(1)}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(permissionsData).map((category) => (
            <TableRow key={category}>
              <TableCell>{category}</TableCell>
              {permissionsList.map((perm) => (
                <TableCell key={perm} className="checkbox-cell">
                  <Controller
                    name={`permissions.${category}.${perm}`}
                    control={control}
                    render={({ field }) => (
                      <Checkbox
                        {...field}
                        checked={field.value}
                        onChange={(e) =>
                          handlePermissionChange(
                            category,
                            perm,
                            e.target.checked
                          )
                        }
                      />
                    )}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PermissionsTable;
